import { useEffect, useState, useMemo } from "react";
import api, { managerApi } from "../services/api";
import ManagerLoginModal from "../components/ManagerLoginModal";
import ItemSizeModal from "../components/ItemSizeModal";
import ItemQtyModal from "../components/ItemQtyModal";
import BRAND from "../components/brand";


export default function OrderPunch() {
  const isTablet = window.innerWidth <= 1024;
  const isMobile = window.innerWidth <= 700;
  console.log("OrderPunch render");
  const [loading, setLoading] = useState(true);
  const [dayLocked, setDayLocked] = useState(false);

  
  // ===== MASTER DATA =====
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [combos, setCombos] = useState([]);

  // ===== UI SELECTION =====
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemSizes, setItemSizes] = useState([]);

  // ===== MODALS =====
  const [showSizeModal, setShowSizeModal] = useState(false);
  const [showQtyModal, setShowQtyModal] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);

  // ===== ORDER STATE =====
  const [liveOrderId, setLiveOrderId] = useState(null);
  const [orderNo, setOrderNo] = useState(null);
  const [orderItems, setOrderItems] = useState([]);

  // ===== CUSTOMER / ORDER DETAILS =====
  const [orderType, setOrderType] = useState("DINE_IN");
  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");

  // ===== PAYMENT STATUS =====
  const [paymentStatus, setPaymentStatus] = useState("DUE");

  // ===== DISCOUNT (MANAGER) =====
  const [discountType, setDiscountType] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [showManagerLogin, setShowManagerLogin] = useState(false);
  const [managerVerified, setManagerVerified] = useState(false);
  const [activeDineOrders, setActiveDineOrders] = useState([]);
  


  const [orderSummary, setOrderSummary] = useState({
    total: 0,
    discount: 0,
    net: 0
  });



// ===== INITIAL LOAD =====
useEffect(() => {
  console.log("Component mounted");

  const start = async () => {
    await init();
    await loadActiveDineOrders();
  };

  start();

}, []);


// ===== AUTO CREATE NEW ORDER =====
const [posMode, setPosMode] = useState("NEW");

useEffect(() => {
  if (!loading && !dayLocked && !liveOrderId && posMode === "NEW") {
    createLiveOrder();
  }
}, [loading, dayLocked, liveOrderId, posMode]);

// ===== KEEP SESSION ALIVE =====
useEffect(() => {
  if (!loading) {
    api.get("/ping").catch(() => {});
  }
}, [loading]);


// ===== ORDER TOTAL CALCULATION =====
useEffect(() => {

  let subtotal = 0;

  orderItems.forEach(i => {
    subtotal += (i.price || 0) * i.qty;
  });

  let discountAmount = 0;

  if (discountType === "VALUE") {
    discountAmount = Number(discountValue || 0);
  }

  if (discountType === "PERCENT") {
    discountAmount = subtotal * (Number(discountValue || 0) / 100);
  }

  const net = Math.max(subtotal - discountAmount, 0);

  setOrderSummary({
    total: subtotal,
    discount: discountAmount,
    net
  });

}, [orderItems, discountType, discountValue]);

const itemsByCategory = useMemo(() => {
    const map = {};
    items.forEach(i => {
      if (!map[i.category_id]) map[i.category_id] = [];
      map[i.category_id].push(i);
    });
    return map;
  }, [items]);


  // ================= LOAD DININ ORDERS =================
const loadActiveDineOrders = async () => {
  try {

    console.log("Loading active dine-in orders...");

    const res = await api.get("/orders/active-dinein");

    console.log("Active dine orders received:", res.data);

    setActiveDineOrders(res.data || []);

  } catch (err) {
    console.error("Failed to load dine-in orders", err);
  }
};

  // ================= INIT =================
  const init = async () => {
  console.log("init() start");

  try {
    console.log("calling /day-end/status");
    const statusRes = await api.get("/day-end/status");
    console.log("day-end/status response", statusRes.data);

    if (statusRes.data.locked) {
      console.log("day is locked");
      setDayLocked(true);
      return;
    }

    console.log("calling /config/init");
    const res = await api.get("/config/init");
    console.log("config/init response received");

    setCategories(res.data.categories || []);
    setItems(res.data.items || []);
    setSizes(res.data.sizes || []);
    setCombos(res.data.combos || []);
  } catch (err) {
    console.error("INIT ERROR", err);
    alert("INIT FAILED – check console");
  } finally {
    console.log("init() finally → setLoading(false)");
    setLoading(false);
  }
};



  const openExistingOrder = async (orderId, orderNo) => {

    setPosMode("EXISTING");

    setLiveOrderId(orderId);
    setOrderNo(orderNo);

    await loadOrderItems(orderId);

  };


  // ================= CATEGORY =================
  const selectCategory = (categoryId) => {
    setSelectedCategory(categoryId);
    setSelectedItem(null);
    setItemSizes([]);
    setFilteredItems(itemsByCategory[categoryId] || []);

  };

  // ================= ITEM CLICK =================
  const selectItem = (item) => {
    setSelectedItem(item);

    if (item.has_size) {
      setItemSizes(sizes.filter(s => s.item_id === item.item_id));
      setShowSizeModal(true);
    } else {
      setSelectedSize(null);
      setShowQtyModal(true);
    }
  };

  // ================= CREATE LIVE ORDER =================
  const createLiveOrder = async () => {
    const res = await api.post("/orders/live", {
      order_type: orderType,
      customer_name: customerName,
      customer_mobile: customerMobile,
      payment_status: paymentStatus
    });

    setLiveOrderId(res.data.live_order_id);
    setOrderNo(res.data.order_no);
    //return res.data.live_order_id;
  };

  // ================= UPDATE PAYMENT STATUS =================
  const updatePaymentStatus = async (status) => {
    setPaymentStatus(status);
    if (liveOrderId) {
      await api.patch(`/orders/live/${liveOrderId}/payment`, {
        payment_status: status
      });
    }
  };

  // ================= LOAD ORDER ITEMS =================
  const loadOrderItems = async (orderId) => {
    const res = await api.get(`/orders/live/${orderId}`);

    setOrderItems(res.data.items || []);
    setOrderSummary({
      total: res.data.subtotal || 0,
      discount: res.data.discount_amount || 0,
      net: res.data.final_amount || 0
    });
  };

// ================= DELETE ITEM =================
const deleteOrderItem = (itemRowId) => {
  if (!liveOrderId) return;

  // 1️⃣ TEMP item → frontend only
  if (String(itemRowId).startsWith("temp-")) {
    setOrderItems(prev => prev.filter(i => i.id !== itemRowId));
    return;
  }

  // 2️⃣ REAL DB item
  const removedItem = orderItems.find(i => i.id === itemRowId);

  setOrderItems(prev => prev.filter(i => i.id !== itemRowId));

  api.delete(`/orders/live/item/${itemRowId}`).catch(() => {
    setOrderItems(prev => [...prev, removedItem]);
    alert("Failed to delete item. Restored.");
  });
};




  // ================= SIZE SELECT =================
  const onSizeSelected = (size) => {
    setSelectedSize(size);
    setShowSizeModal(false);
    setShowQtyModal(true);
  };

  // ================= QTY CONFIRM =================
const onQtyConfirm = async (qty) => {
  
const orderId = liveOrderId;
if (!orderId) return;

  // 1️⃣ Create temp item for instant UI
  const tempItem = {
    id: `temp-${Date.now()}`,
    item_name: selectedItem.item_name,
    size_name: selectedSize ? selectedSize.size_name : null,
    qty,
    price: selectedSize?.price || selectedItem.price || 0
  };

  // 2️⃣ Add item to UI immediately
  setOrderItems(prev => [...prev, tempItem]);

  // 3️⃣ Call backend in background
  api.post(`/orders/live/${orderId}/item`, {
  item_id: selectedItem.item_id,
  size_id: selectedSize ? selectedSize.size_id : null,
  qty
})
.then(res => {
  const realId = res.data.id;

  // 🔁 Replace temp item with DB item
  setOrderItems(prev =>
    prev.map(i =>
      i.id === tempItem.id ? { ...i, id: realId } : i
    )
  );
})
.catch(() => {
  setOrderItems(prev => prev.filter(i => i.id !== tempItem.id));
  alert("Failed to add item. Please retry.");
});

  // 5️⃣ Close modal immediately
  setShowQtyModal(false);
  setSelectedItem(null);
  setSelectedSize(null);
};


  // ================= APPLY DISCOUNT =================
  const applyDiscount = async () => {
    if (!discountType || !discountValue) {
      alert("Select discount type and value");
      return;
    }

    if (!managerVerified) {
      setShowManagerLogin(true);
      return;
    }

    await managerApi.post(`/orders/${liveOrderId}/discount`, {
      type: discountType,
      value: discountValue
    });

    await loadOrderItems(liveOrderId);

    setDiscountType("");
    setDiscountValue("");
    alert("Discount applied");
  };

  // ================= RESET =================
  const resetOrderPunch = async () => {

  if (liveOrderId && orderItems.length === 0) {
    try {
      await api.delete(`/orders/live/${liveOrderId}`);
    } catch (err) {
      console.error("Cancel draft failed", err);
    }
  }
    setLiveOrderId(null);
    setPosMode("NEW");
    setOrderNo(null);
    setOrderItems([]);
    setOrderType("DINE_IN");
    setCustomerName("");
    setCustomerMobile("");
    setPaymentStatus("DUE");
    setSelectedCategory(null);
    setFilteredItems([]);
    setSelectedItem(null);
    setItemSizes([]);
    setManagerVerified(false);
    loadActiveDineOrders(); 
  };


  if (loading) return <div style={{ padding: 40 }}>Loading...</div>;

  if (dayLocked) {
    return (
      <div style={{ padding: 40 }}>
        <h2>Order Punch</h2>
        <p style={{ color: "red" }}>
          🚫 Day is locked. No new orders can be created.
        </p>
      </div>
    );
  }

  return (
    <>
    {/* ===== HEADER ===== */}

      <div
  style={{
    display: "flex",
    flexDirection: window.innerWidth < 900 ? "column" : "row",
    padding: 10,
    gap: 10
  }}
>
        {/* LEFT */}
        <div style={{ flex: 2 }}>
          <h2 style={{ 
  fontSize: 22, 
  marginBottom: 10 
}}>
  Order Punch
  {orderNo && (
    <span style={{ fontSize: 16, fontWeight: 400, marginLeft: 10 }}>
      #{orderNo}
    </span>
  )}
</h2>

         <h3>Categories</h3>

<div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
  {categories.map(cat => (
    <button
      key={cat.category_id}
      onClick={() => selectCategory(cat.category_id)}
      style={{
        padding: isMobile ? "12px" : "8px 14px",
        fontSize: isMobile ? 15 : 13,
        borderRadius: 8,
        border: "1px solid #e5e7eb",
        background:
          selectedCategory === cat.category_id
            ? "#2563eb"
            : "#ffffff",
        color:
          selectedCategory === cat.category_id
            ? "#ffffff"
            : "#111827",
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 500
      }}
    >
      {cat.category_name}
    </button>
  ))}
</div>


    <h3 style={{ marginTop: 20 }}>Items</h3>

<div
  style={{
    display: "grid",
   gridTemplateColumns: isMobile
  ? "repeat(2,1fr)"
  : isTablet
  ? "repeat(3,1fr)"
  : "repeat(auto-fill, minmax(140px, 1fr))",
    gap: 10
  }}
>
  {filteredItems.map(item => (
    <div
      key={item.item_id}
      onClick={() => selectItem(item)}
      style={{
        border: "1px solid #ccc",
        borderRadius: 8,
        padding: isMobile ? 16 : 12,
        fontSize: isMobile ? 16 : 14,
        textAlign: "center",
        cursor: "pointer",
        background: "#fff",
        fontWeight: 500
      }}
    >
      {item.item_name}
    </div>
  ))}
</div>

          
        </div>

        {/* RIGHT */}
          <div
            style={{
              flex: isTablet ? "none" : 1,
              width: isTablet ? "100%" : "350px",
              marginLeft: isTablet ? 0 : 30,
              paddingLeft: 20
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: 16,
               boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                minHeight: window.innerWidth < 900 ? "auto" : "80vh",
                display: "flex",
                flexDirection: "column"
              }}
            >

          <div style={{ borderBottom: "1px dashed #ccc", paddingBottom: 10, marginBottom: 10 }}>
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <strong>Order #{orderNo || "--"}</strong>
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 12,
        background: paymentStatus === "PAID" ? "#16a34a" : "#f97316",
        color: "#fff",
        fontSize: 12
      }}
    >
      {paymentStatus === "PAID" ? "PAID" : "PAY AT CLOSE"}
    </span>
  </div>

  <div style={{ fontSize: 12, color: "#555", marginTop: 4 }}>
    {orderType}
  </div>
</div>


<div
  style={{
    background: "#f8fafc",
    padding: 8,
    borderRadius: 8,
    marginBottom: 10,
    display: "flex",
    flexDirection: "column",
    gap: 6
  }}
>
  {/* Order type */}
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <span style={{ fontSize: 12, color: "#555", width: 70 }}>
      Order
    </span>
    <select
      value={orderType}
      onChange={e => setOrderType(e.target.value)}
      style={{
        flex: 1,
        padding: "4px 6px",
        fontSize: 13,
        borderRadius: 6,
        border: "1px solid #ccc"
      }}
    >
      <option value="DINE_IN">Dine In</option>
      <option value="TAKE_AWAY">Take Away</option>
      <option value="DELIVERY">Delivery</option>
    </select>
  </div>

  {/* Customer name */}
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <span style={{ fontSize: 12, color: "#555", width: 70 }}>
      Name
    </span>
    <input
      value={customerName}
      onChange={e => setCustomerName(e.target.value)}
      placeholder="Optional"
      style={{
        flex: 1,
        padding: "4px 6px",
        fontSize: 13,
        borderRadius: 6,
        border: "1px solid #ccc"
      }}
    />
  </div>

  {/* Mobile */}
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <span style={{ fontSize: 12, color: "#555", width: 70 }}>
      Mobile
    </span>
    <input
      value={customerMobile}
      onChange={e => setCustomerMobile(e.target.value)}
      placeholder="Optional"
      style={{
        flex: 1,
        padding: "4px 6px",
        fontSize: 13,
        borderRadius: 6,
        border: "1px solid #ccc"
      }}
    />
  </div>
</div>

<h3>Active Dine-In</h3>

{activeDineOrders.length === 0 && (
  <div style={{fontSize:12,color:"#666"}}>
    No active dine-in orders
  </div>
)}

{activeDineOrders.map(o => (

  <div
    key={o.live_order_id}
    style={{
      border:"1px solid #ddd",
      padding:6,
      borderRadius:6,
      marginBottom:5,
      cursor:"pointer"
    }}
    onClick={() => openExistingOrder(o.live_order_id, o.order_no)}
  >
    <strong>#{o.order_no}</strong>
    <span style={{marginLeft:10,fontSize:12}}>
      {o.order_status}
    </span>
  </div>

))}


<h3
  style={{
    borderBottom: "1px dashed #ccc",
    paddingBottom: 6,
    marginBottom: 8
  }}
>
  Items
</h3>


          {orderItems.length === 0 && <p>No items added</p>}

          {orderItems.length > 0 && (
            <>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
  {orderItems.map(i => (
    <div
      key={i.id}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        border: "1px solid #e5e7eb",
        borderRadius: 6,
        padding: "6px 8px",
        background: "#fafafa",
        fontSize: 13
      }}
    >
      {/* LEFT: Name + size + qty */}
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, lineHeight: "16px" }}>
          {i.item_name}
          {i.size_name && (
            <span style={{ fontWeight: 400 }}> ({i.size_name})</span>
          )}
        </div>
        <div style={{ fontSize: 11, color: "#666" }}>
          {i.qty} × ₹{i.price || 0}
        </div>
      </div>

      {/* RIGHT: Amount + delete */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginLeft: 8
        }}
      >
        <div style={{ fontWeight: 600 }}>
          ₹{(i.price || 0) * i.qty}
        </div>

        <button
          onClick={() => deleteOrderItem(i.id)}
          style={{
            background: "transparent",
            color: "#b00020",
            border: "none",
            fontSize: 16,
            cursor: "pointer",
            lineHeight: "14px"
          }}
          title="Remove item"
        >
          ×
        </button>
      </div>
    </div>
  ))}
</div>



{/* TOTALS */}
        <div style={{
          borderTop: "1px solid #f1f5f9",
          paddingTop: 10,
          marginTop: 10
        }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between"
          }}>
            <span>Subtotal</span>
            <strong>₹{orderSummary.total}</strong>
          </div>

          {orderSummary.discount > 0 && (
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              color: "#16a34a"
            }}>
              <span>Discount</span>
              <strong>-₹{orderSummary.discount}</strong>
            </div>
          )}

          <div style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 18,
            marginTop: 8
          }}>
            <strong>Payable</strong>
            <strong>₹{orderSummary.net}</strong>
          </div>
        </div>



              <h4>Discount (Manager)</h4>
              <select value={discountType} onChange={e => setDiscountType(e.target.value)}>
                <option value="">None</option>
                <option value="VALUE">₹ Value</option>
                <option value="PERCENT">%</option>
              </select>

              {discountType && (
                <>
                  <input
                    type="number"
                    value={discountValue}
                    onChange={e => setDiscountValue(e.target.value)}
                    style={{ marginLeft: 8 }}
                  />
                  <button onClick={applyDiscount} style={{ marginLeft: 8 }}>
                    Apply
                  </button>
                </>
              )}

              <div style={{ marginTop: 10 }}>
                <label>
                  <input
                    type="radio"
                    checked={paymentStatus === "PAID"}
                    onChange={() => updatePaymentStatus("PAID")}
                  />
                  Paid (Upfront)
                </label>

                <label style={{ marginLeft: 20 }}>
                  <input
                    type="radio"
                    checked={paymentStatus === "DUE"}
                    onChange={() => updatePaymentStatus("DUE")}
                  />
                  Pay at Close
                </label>
              </div>
              <div style={{ marginTop: "auto" }}>
 
 {/* CANCEL BUTTON */}
{liveOrderId && orderItems.length >= 0 && (
  <button
    style={{
      marginTop: 10,
      width: "100%",
      padding: "10px",
      fontSize: 14,
      fontWeight: 600,
      background: "#dc2626",
      color: "#fff",
      border: "none",
      borderRadius: 12,
      cursor: "pointer"
    }}
    onClick={async () => {

      const confirmCancel = window.confirm(
        `Cancel Order #${orderNo}?`
      );

      if (!confirmCancel) return;

      try {

        await api.delete(
          `/orders/live/${liveOrderId}/cancel`
        );

        alert("Order cancelled");

        resetOrderPunch();

      } catch (err) {
        console.error(err);
        alert("Cannot cancel. Order may already be sent.");
      }

    }}
  >
    CANCEL ORDER
  </button>
)}
 
  
 
 
  {/* SEND BUTTON */}
        <button
          style={{
            marginTop: 20,
            width: "100%",
            padding: "12px",
            fontSize: 15,
            fontWeight: 600,
            background: "#2563eb",
            color: "#fff",
            border: "none",
            borderRadius: 12,
            cursor: "pointer"
          }}
          onClick={async () => {

            if (!liveOrderId) return;

            if (orderItems.length === 0) {
              alert("Please add items before sending to kitchen.");
              return;
            }

            try {

              // 1️⃣ Update live order details FIRST
              await api.patch(`/orders/live/${liveOrderId}`, {
                order_type: orderType || "DINE_IN",
                customer_name: customerName || null,
                customer_mobile: customerMobile || null
              });
              // 2️⃣ Now send to kitchen (this should change status to PUNCHED internally)
              await api.post(`/orders/${liveOrderId}/send-to-kitchen`);

              alert(`Order #${orderNo} sent to Kitchen`);

              resetOrderPunch();

            } catch (err) {
              console.error(err);
              alert("Failed to send order.");
            }

          }}
        >
          SEND TO KITCHEN
        </button>
</div>

            </>
          )}
        </div>
      </div>
    </div>
      <ItemSizeModal
        open={showSizeModal}
        item={selectedItem}
        sizes={itemSizes}
        onSelect={onSizeSelected}
        onClose={() => setShowSizeModal(false)}
      />

      <ItemQtyModal
        open={showQtyModal}
        item={selectedItem}
        size={selectedSize}
        onConfirm={onQtyConfirm}
        onClose={() => setShowQtyModal(false)}
      />

      {showManagerLogin && (
        <ManagerLoginModal
          onSuccess={() => {
            setManagerVerified(true);
            setShowManagerLogin(false);
            alert("Manager verified. Click Apply again.");
          }}
          onClose={() => setShowManagerLogin(false)}
        />
      )}
    </>
  );
}
